export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 mb-8">如有资源需求、内容建议或合作意向，欢迎随时与我们联系</p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿邮箱</div>
                <div className="font-medium">tougao@51video.com</div>
              </div>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-customer-service-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">客服邮箱</div>
                <div className="font-medium">kefu@51video.com</div>
              </div>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-shake-hands-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">商务合作</div>
                <div className="font-medium">hezuo@51video.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}